import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

export default function initPostSlider() {
  const sliders = document.querySelectorAll('.aviatrix-block--post-slider .post-slider__slider');

  sliders.forEach(root => {
    const swiperEl = root.querySelector('.post-slider__swiper');
    const prevEl   = root.querySelector('.post-slider__nav--prev');
    const nextEl   = root.querySelector('.post-slider__nav--next');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      modules: [Navigation, A11y, Keyboard],
      slidesPerView: 1,
      spaceBetween: 32,
      watchSlidesProgress: true,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        prevSlideMessage: 'Previous post',
        nextSlideMessage: 'Next post',
        firstSlideMessage: 'This is the first post',
        lastSlideMessage: 'This is the last post',
      },
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        782: {
          slidesPerView: 1,
          spaceBetween: 48,
        },
      },
    });
  });
}
